import React from 'react';

interface JobTypeBadgeProps {
  jobType: string | null | undefined;
}

const getJobTypeStyles = (jobType: string | null | undefined): { bgColor: string; textColor: string } => {
  if (!jobType) {
    return { bgColor: 'bg-gray-100', textColor: 'text-gray-800' };
  }

  const lowerCaseType = jobType.toLowerCase();

  if (lowerCaseType.includes('long term')) {
    return { bgColor: 'bg-blue-100', textColor: 'text-blue-800' };
  }
  if (lowerCaseType.includes('short term')) {
    return { bgColor: 'bg-yellow-100', textColor: 'text-yellow-800' };
  }
  
  return { bgColor: 'bg-gray-100', textColor: 'text-gray-800' };
};

const JobTypeBadge: React.FC<JobTypeBadgeProps> = ({ jobType }) => {
  if (!jobType) {
    return null;
  }

  const { bgColor, textColor } = getJobTypeStyles(jobType);

  return (
    <span className={`inline-block px-3 py-1 text-sm font-medium rounded-full ${bgColor} ${textColor}`}>
      {jobType}
    </span>
  );
};

export default JobTypeBadge;
